
<ion-menu class='main-menu' side="start" menuId="first" contentId="main">
  <ion-header>
    <ion-toolbar color="primary">
      <ion-title>Menu</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-item (click)="showAbout()">About</ion-item>
      <ion-item (click)="menu.close()" [routerLink]="['startup']" detail routerDirection="forward" routerLinkActive="active" > App Getting started</ion-item>
      <ion-item (click)="purchaseSubscription()">Subscriptions and Purchase options</ion-item>
      <ion-item (click)="openPurchases()">My Purchases</ion-item>
      <ion-item (click)="menu.close()" [routerLink]="['/new-features']">Features/Access</ion-item>
      <ion-item (click)="menu.close()" [routerLink]="['/sound-tester']">Sound Demonstration</ion-item>
 
      <!--
 <ion-item [routerLink]="['/auth-kb']">Song Maker </ion-item>
      
 -->
     
    </ion-list>
  </ion-content>
</ion-menu>

<ion-menu side="start" menuId="custom" contentId="main" class="my-custom-menu">
  <ion-header>
    <ion-toolbar color="tertiary">
      <ion-title>Menu</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-item  [routerLink]="['/startup']" > Getting started </ion-item>
    <ion-item (click)="menu.close()" [routerLink]="['/sound-tester']">Sound Demonstration</ion-item>
     
    <ion-item (click)="purchaseSubscription()">Subscriptions and Purchase options</ion-item>
    <ion-item (click)="openPurchases()">My Purchases</ion-item>
 
     
    </ion-list>
  </ion-content>
</ion-menu>

<ion-menu side="end" type="push" contentId="main">
  <ion-header>
    <ion-toolbar color="danger">
      <ion-title>End Menu</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-item>Menu Item</ion-item>
      <ion-item>Menu Item</ion-item>
      <ion-item>Menu Item</ion-item>
      <ion-item>Menu Item</ion-item>
      <ion-item>Menu Item</ion-item>
    </ion-list>
  </ion-content>
</ion-menu>
<ion-app class='noscroll  body'> 
  <ion-router-outlet id=main></ion-router-outlet>
</ion-app>
